import { http } from '@/utils/http' // eslint-disable-line
// import { loadDataRecursively } from '@/utils/common'

export default {
  // updateCode (updateData) {
  //   const update = updateData.scmData
  //   // const txnId = await new Promise((resolve, reject) => {
  //   //   axiosInstance.post('cardano.com/api/scm', hash(update))
  //   //     .then(res => resolve(res.data...transaction_id))
  //   //     .catch(err => reject(err))
  //   // })
  //   const txnId = 'yourtxnidwillbeherelater'
  //   update['transaction_id'] = txnId
  //   update['extended_id'] = updateData.code.extendedId
  //   return new Promise((resolve, reject) => {
  //     http.st.post('/scm/upload/', {
  //       data_key: 'extended_id',
  //       items: [update]
  //     }).then(async (res) => {
  //       const resData = res.data
  //       resolve(resData)
  //     }).catch((err) => {
  //       reject(err)
  //     })
  //   })
  // },

  loadCodes (search) {
    return new Promise((resolve, reject) => {
      http.st.get(`/codes/?campaign=451&ordering=-created_at&search=${search || ''}`).then(async (res) => {
      // http.st.get(`/codes/?ordering=-created_at&search=${search || ''}`).then(async (res) => {
        const resData = res.data
        // resData.results = resData.results.concat(await loadDataRecursively(resData.next))
        resolve(resData)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  fetchByExtendedId (id) {
    return new Promise((resolve, reject) => {
      http.st.get(`/codes/?campaign=451&search=${id}`).then(async (res) => {
      // http.st.get(`/codes/?search=${id}`).then(async (res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}
